import { Badge } from '@lightspeed/unified-components-helios-theme/react'
import { T } from '@transifex/react'
import React from 'react'
import {
  AVAILABILITY_BADGE_APPEARANCES,
  AvailabilityBadgeAppearance,
} from '../OutletSelectTypes'

const getAvailabilityBadgeAppearance = (
  available: number
): AvailabilityBadgeAppearance => {
  if (available <= 0) {
    return AVAILABILITY_BADGE_APPEARANCES.danger
  }

  if (available === 1) {
    return AVAILABILITY_BADGE_APPEARANCES.warning
  }

  return AVAILABILITY_BADGE_APPEARANCES.success
}

export const AvailabilityBadge: React.FC<{ available: number }> = ({
  available,
}) => (
  <Badge
    appearance={getAvailabilityBadgeAppearance(available)}
    customClasses={{ container: 'shrink-0' }}
  >
    {available < 0 ? (
      <T
        _str="{oversold, plural, one {{oversold} oversold} other {{oversold} oversold}}"
        oversold={-available}
        _context="Popover header"
      />
    ) : (
      <T
        _str="{available, plural, one {{available} available} other {{available} available}}"
        available={available}
        _context="Popover header"
      />
    )}
  </Badge>
)
